// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineTask = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 20.25H11C10.59 20.25 10.25 19.91 10.25 19.5C10.25 19.09 10.59 18.75 11 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 13.25H11C10.59 13.25 10.25 12.91 10.25 12.5C10.25 12.09 10.59 11.75 11 11.75H21C21.41 11.75 21.75 12.09 21.75 12.5C21.75 12.91 21.41 13.25 21 13.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 6.25H11C10.59 6.25 10.25 5.91 10.25 5.5C10.25 5.09 10.59 4.75 11 4.75H21C21.41 4.75 21.75 5.09 21.75 5.5C21.75 5.91 21.41 6.25 21 6.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.99945 7.24994C3.80945 7.24994 3.61945 7.17994 3.46945 7.02994L2.46945 6.02994C2.17945 5.73994 2.17945 5.25994 2.46945 4.96994C2.75945 4.67994 3.23945 4.67994 3.52945 4.96994L3.99945 5.43994L6.46945 2.96994C6.75945 2.67994 7.23945 2.67994 7.52945 2.96994C7.81945 3.25994 7.81945 3.73994 7.52945 4.02994L4.52945 7.02994C4.37945 7.17994 4.18945 7.24994 3.99945 7.24994Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.99945 14.2499C3.80945 14.2499 3.61945 14.1799 3.46945 14.0299L2.46945 13.0299C2.17945 12.7399 2.17945 12.2599 2.46945 11.9699C2.75945 11.6799 3.23945 11.6799 3.52945 11.9699L3.99945 12.4399L6.46945 9.96994C6.75945 9.67994 7.23945 9.67994 7.52945 9.96994C7.81945 10.2599 7.81945 10.7399 7.52945 11.0299L4.52945 14.0299C4.37945 14.1799 4.18945 14.2499 3.99945 14.2499Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.99945 21.2499C3.80945 21.2499 3.61945 21.1799 3.46945 21.0299L2.46945 20.0299C2.17945 19.7399 2.17945 19.2599 2.46945 18.9699C2.75945 18.6799 3.23945 18.6799 3.52945 18.9699L3.99945 19.4399L6.46945 16.9699C6.75945 16.6799 7.23945 16.6799 7.52945 16.9699C7.81945 17.2599 7.81945 17.7399 7.52945 18.0299L4.52945 21.0299C4.37945 21.1799 4.18945 21.2499 3.99945 21.2499Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineTask };
